import { z } from 'zod';

export const companyBlockUnblockSchema = z.object({
  reason: z
    .string({ message: 'Campo obrigatório' })
    .min(1, { message: 'Campo obrigatório' })
    .max(500, { message: 'O motivo deve ter no máximo 500 caracteres' }), 
});

export type CompanyBlockUnblockValidationSchema = z.infer<typeof companyBlockUnblockSchema>;